import React from 'react'
import styled from 'styled-components'
import { CardProps, Text } from 'rebass'
import { Box } from 'rebass/styled-components'

interface ModernCardProps {
  width?: string
  padding?: string
  border?: string
  borderRadius?: string
  hover?: boolean
  glow?: boolean
}

const Card = styled(Box)<ModernCardProps>`
  width: ${({ width }) => width ?? '100%'};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  padding: ${({ padding, theme }) => padding || theme.spacing.lg};
  border: ${({ border }) => border || '1px solid transparent'};
  border-radius: ${({ borderRadius, theme }) => borderRadius || theme.borderRadius.large};
  background-color: ${({ theme }) => theme.bg1};
  box-shadow: ${({ theme }) => theme.shadow1};
  transition: all ${({ theme }) => theme.transitions.normal};
  position: relative;

  ${({ hover, theme }) => hover && `
    &:hover {
      box-shadow: ${theme.shadow2};
      transform: translateY(-1px);
      border-color: ${theme.bg4};
    }
  `}

  ${({ glow, theme }) => glow && `
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: ${theme.borderRadius.large};
      padding: 1px;
      background: linear-gradient(135deg, ${theme.primary1}, ${theme.primary2});
      mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
      mask-composite: xor;
      -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      pointer-events: none;
    }
  `}
`
export default Card

export const LightCard = styled(Card)`
  border: 1px solid ${({ theme }) => theme.bg2};
  background-color: ${({ theme }) => theme.bg1};
  box-shadow: none;
`

export const LightGreyCard = styled(Card)`
  background-color: ${({ theme }) => theme.bg2};
  border-color: ${({ theme }) => theme.bg3};
  box-shadow: none;
`

export const GreyCard = styled(Card)`
  background-color: ${({ theme }) => theme.bg3};
  border-color: ${({ theme }) => theme.bg4};
`

export const OutlineCard = styled(Card)`
  border: 2px solid ${({ theme }) => theme.primary1};
  background: transparent;
  box-shadow: none;
`

export const YellowCard = styled(Card)`
  background-color: rgba(243, 132, 30, 0.05);
  color: ${({ theme }) => theme.yellow2};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  border: 1px solid rgba(243, 132, 30, 0.15);
`

export const PinkCard = styled(Card)`
  background-color: rgba(255, 0, 122, 0.03);
  color: ${({ theme }) => theme.primary1};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  border: 1px solid ${({ theme }) => theme.primary4};
`

export const GradientCard = styled(Card)`
  background: linear-gradient(135deg, ${({ theme }) => theme.primary5} 0%, ${({ theme }) => theme.bg1} 100%);
  border: 1px solid ${({ theme }) => theme.primary4};
  color: ${({ theme }) => theme.primaryText1};
`

const BlueCardStyled = styled(Card)`
  background-color: ${({ theme }) => theme.primary5};
  color: ${({ theme }) => theme.primary1};
  border-radius: 12px;
  width: fit-content;
`

export const BlueCard = ({ children, ...rest }: CardProps) => {
  return (
    <BlueCardStyled {...rest}>
      <Text fontWeight={500} color="#2172E5">
        {children}
      </Text>
    </BlueCardStyled>
  )
}
